// Türkçe karakter duyarlı URL slug üretimi.
// Kategori URL'leri (/kategori/:slug) ile backend sitemap eşleşmesinde aynı kural kullanılır.
export function slugifyTr(input) {
  if (!input) return "";
  const map = { ç: "c", ğ: "g", ı: "i", İ: "i", ö: "o", ş: "s", ü: "u", Ç: "c", Ğ: "g", Ö: "o", Ş: "s", Ü: "u" };
  return String(input)
    .replace(/[çğıİöşüÇĞÖŞÜ]/g, (m) => map[m] || m)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
